import shakeChoco from '@assets/images/shake-choco.png';
import shakeFresa from '@assets/images/shake-fresa.png';

export const Images = {
    shakeChoco,
    shakeFresa
}